module.exports = __webpack_public_path__ + "static/img_2537-b7dddb95925945c64777370a7a23e4cd.webp";